import {
  TimeframeTypeCodeDto,
  EnergyTypeDto,
  DirectionTypeCodeDto,
  RegisterType,
} from '@eneco/dc-be/client';

export function mapToTimeframeType(value: string): TimeframeTypeCodeDto | undefined {
  const TIMEFRAME_VALUES: TimeframeTypeCodeDto[] = ['TH', 'HI', 'LO', 'EX'];
  return TIMEFRAME_VALUES.includes(value as TimeframeTypeCodeDto) ? (value as TimeframeTypeCodeDto) : undefined;
}

export function mapToEnergyType(value: string): EnergyTypeDto {
  switch (value) {
    case 'Electricity':
      return 'Electricity';
    case 'Gas':
      return 'Gas';
    default:
      return 'Electricity';
  }
}

export function mapToDirectionType(value: string): DirectionTypeCodeDto {
  switch (value) {
    case 'Consumption':
      return 'OffTake';
    case 'Production':
      return 'Injection';
    case 'Injection':
      return 'Injection';
    case 'Offtake':
      return 'OffTake';
    default:
      return 'OffTake';
  }
}

export function mapFromTimeframeType(value: RegisterType): TimeframeTypeCodeDto {
  switch (value) {
    case 'Single':
      return 'TH';
    case 'Day':
      return 'HI';
    case 'Night':
      return 'LO';
    case 'ExclusiveNight':
      return 'EX';
    default:
      return 'TH';
  }
}

export function mapToRegisterType(value: TimeframeTypeCodeDto): RegisterType {
  switch (value) {
    case 'TH':
      return 'Single';
    case 'HI':
      return 'Day';
    case 'LO':
      return 'Night';
    case 'EX':
      return 'ExclusiveNight';
    default:
      return 'Single';
  }
}
